import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as supervisionActions from 'redux/modules/supervision';

import { Button } from 'react-bootstrap';


require('moment/locale/fr');

import { translate } from 'react-i18next';
import moment from 'moment';

@translate(['common'])
@connect(
	state => ({
		loading: state.supervision.loading,
		user: state.auth.user,
		csv_data: state.supervision.csv_data,
		supervisionNb:state.supervision.supervisionNb,
		csv_loading: state.supervision.csv_loading,
		mainLoading:state.supervision.mainLoading
	}),
	dispatch => bindActionCreators({ ...supervisionActions }, dispatch)
)

export default class ExportCSVForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      begin_date: false,
      end_date: false,
      filter: false,
      columnSort: false,
      allFiches: false,
      disableDate: false,
      loading: false,
      progress: 0
    };

    this.exporting = false; // Nouvelle variable de classe pour suivre l'état de l'exportation
    this.exportPromise = null; // Nouvelle variable de classe pour stocker la promesse d'exportation
  }

  componentDidMount() {
    this.exporting = false;
    this.exportPromise = null;
  }

  componentWillUnmount() {
	  this.exporting = false; // Réinitialise l'état d'exportation lors du démontage du composant
	  this.props.activateMainLoading(false);
  }

	exportCSV() {
	  
    this.setState({ loading: true });
    this.exporting = true;
    var filter = this.props.filter;
    var supervisionNb = this.props.supervisionNb;

    const CSV = (array) => {

      var keys = Object.keys(array[0]);

      var result = '\ufeff' + keys.join(';') + '\n';

      array.forEach(function (obj) {
        keys.forEach(function (k, ix) {
          if (ix) result += ';';
          result += obj[k];
        });
        result += '\n';
      });

      return result;
    };

    var columns = filter.columSort ? this.props.columns : null;
    var allRows = [];

    this.props.activateMainLoading(true);

    this.exportPromise = this.props.exportCSV(this.props.urlParams, filter, columns, supervisionNb, 0);
    this.exportPromise
      .then((result) => {
        if (!this.exporting) return; // Vérifie si l'exportation a été annulée avant de poursuivre

        const { chunkIndex, chunksTotal, rows, supervisionNb } = result;

        allRows.push(...rows);

        var maxOffsets = Math.ceil(supervisionNb / 5000);
        
        var batchSize = 3

        this.exportBatches(1, maxOffsets, batchSize, allRows)
          .then(() => {
            if (!this.exporting) return; // Vérifie si l'exportation a été annulée avant de poursuivre

            this.props.activateMainLoading(false);

            // Tous les batches sont terminés

            // Mettre à jour le state pour indiquer que la progression est terminée
            this.setState({ progress: 100 });

            // Autres opérations à effectuer une fois que la progression est terminée
            // Mettez votre logique ici
            if (allRows.length == 0) {
              alert('Aucune données')
              this.props.activateMainLoading(false);
              this.setState({ loading: false });
              return
            }

            allRows = allRows.map(obj => ({ ...obj, date_reference: moment.unix(obj.date_reference_unix).format('DD/MM/YYYY HH:mm:ss') })).map(({ date_reference, ...rest }) => ({ ...rest, date_reference }));

            allRows = [...new Map(allRows.map(obj => [JSON.stringify(obj), obj])).values()];


            var csv = CSV(allRows);
            if (csv) {
              var filename = 'export_supervision_' + Date.now() + '.csv';
              var blob = new Blob([csv], { type: 'text/csv' });

              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
              } else {
                var elem = window.document.createElement('a');
                elem.href = window.URL.createObjectURL(blob);
                elem.download = filename;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
              }

              this.setState({ loading: false });
              
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.exporting = false; // Réinitialise l'état d'exportation
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  exportBatches(startOffset, maxOffsets, batchSize, allRows) {
    if (!this.exporting) {
      return Promise.reject('Exportation annulée');
    }

    var offset = startOffset;
    var batchPromises = [];

    while (offset <= maxOffsets && offset < startOffset + batchSize) {
      batchPromises.push(this.props.exportCSV(this.props.urlParams, this.props.filter, this.props.columns, this.props.supervisionNb, offset));
      offset++;
    }

    return Promise.all(batchPromises)
      .then((batchResults) => {
        if (!this.exporting) {
          return Promise.reject('Exportation annulée');
        }

        batchResults.forEach((result) => {
          const { chunkIndex, chunksTotal, rows, supervisionNb } = result;
          allRows.push(...rows);
        });

        var completedBatches = startOffset + batchSize - 1; // Compteur des batches terminés

        // Mettre à jour le state avec la progression
        this.setState({ progress: Math.round((completedBatches / maxOffsets) * 100) });

        if (offset <= maxOffsets) {
          return this.exportBatches(offset, maxOffsets, batchSize, allRows);
        }

        return Promise.resolve();
      });
  }

  // Nouvelle méthode pour tester l'export serveur
  exportCSVNew() {
    const filter = this.props.filter;
    const urlParams = this.props.urlParams;
    
    // Vérifier si des filtres sont appliqués
    const hasFilters = filter && (
      (filter.idList && filter.idList.length > 0) ||
      (filter.numAscList && filter.numAscList.length > 0) ||
      (filter.causesList && filter.causesList.length > 0) ||
      (filter.begin_date && !filter.allTime) ||
      (filter.end_date && !filter.allTime)
    );
    
    if (!hasFilters) {
      if (!window.confirm('Aucun filtre appliqué. L\'export contiendra TOUTES les données et peut prendre du temps. Continuer ?')) {
        return;
      }
    }
    
    this.setState({ loadingNew: true });
    
    // Récupérer le token CSRF depuis le cookie
    const csrfToken = document.cookie
      .split('; ')
      .find(row => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1];
    
    // Appel direct à l'API qui retourne un fichier CSV
    fetch('/api/supervision/exportCSVStream', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': decodeURIComponent(csrfToken || ''),
      },
      credentials: 'include',
      body: JSON.stringify({
        params: urlParams,
        filter: filter
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Erreur export');
      return response.blob();
    })
    .then(blob => {
      // Télécharger le fichier
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `export_supervision_${Date.now()}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      this.setState({ loadingNew: false });
    })
    .catch(err => {
      console.error('Erreur export CSV:', err);
      alert('Erreur lors de l\'export');
      this.setState({ loadingNew: false });
    });
  }

  render() {
    const { user } = this.props;
    var style = { display: this.state.disableDate ? 'none' : 'block' };
    var self = this;

    return (
      <span>
        {/* Ancien export désactivé - garder pour rollback si besoin
        <Button bsStyle="warning" disabled={this.state.loading || this.props.mainLoading} type="button" onClick={() => { self.exportCSV(); }}>
          <i className={'fa ' + (this.state.loading ? 'fa-cog fa-spin' : 'fa-file')} /> &nbsp;
          Export CSV
          {this.state.loading && <span>&nbsp;{this.state.progress} %</span>}
        </Button>
        {' '}
        */}
        <Button bsStyle="warning" disabled={this.state.loadingNew || this.props.mainLoading} type="button" onClick={() => { self.exportCSVNew(); }}>
          <i className={'fa ' + (this.state.loadingNew ? 'fa-cog fa-spin' : 'fa-file')} /> &nbsp;
          Export CSV
        </Button>
      </span>
    );
  }
}

